import { ReactComponent as Icon } from "../assets/icons/chats/ExitGroup.svg";
import genIcons from "./genIcons";

const ExitGroup = { filled: genIcons(Icon, { htmlColor: "transparent" }) };

export default ExitGroup;
